import React from 'react';

import BaseView from './BaseView';

const LikesView = () => (
  <BaseView title="Likes" backurl="/" underConstruction>
    <p style={{ marginTop: 52 }}> I&apos;m likes page </p>
  </BaseView>
);

export default LikesView;
